export enum EAgreementPartsTypes {
  Text = 'text',
  Link = 'link',
  Modal = 'modal',
}
